import { theme } from 'styles/theme'

// SC-11275: no celular (360px no Moto G22/Galaxy S23) título + chip de status
// + ações não cabem na linha do ModalHeader da lib (~280px úteis). A linha
// vazava por baixo do X, que não encolhe: cobria o status e jogava as ações
// para fora da tela. Abaixo de `sm` os headers de detalhe usam duas linhas:
// título, "Mais opções" e X em cima; status em largura total embaixo.
export const mobile = theme.breakpoints.down('sm')

// O X é renderizado pela lib depois dos children, fora do grid. Fixo no canto
// da linha do título, ele deixa o status ocupar a largura toda embaixo. top
// centraliza o botão (40px) na linha de 44px do IconContainer abaixo do
// padding de 16px; right repete a borda do m:-4px original.
export const modalHeaderMobileSx = {
  [mobile]: {
    position: 'relative',
    '& > .MuiIconButton-root': {
      position: 'absolute',
      top: '18px',
      right: '20px',
      m: 0
    }
  }
}

// A última coluna da primeira linha guarda o lugar do X. Os filhos se
// posicionam com `gridArea` (title, more, status); um grupo intermediário
// precisa de `display: contents` no mobile para não virar célula única.
export const headerGridMobileSx = {
  [mobile]: {
    display: 'grid',
    gridTemplateColumns: '1fr auto 24px',
    gridTemplateAreas: '"title more ." "status status status"',
    alignItems: 'center',
    gap: 1,
    mr: 0
  }
}
